import { useCurrentProjectId, useCurrentToolId } from '@adsk/alloy-provider';

import { getBaseScheduleFEUrl } from '../../helpers';
import { Task } from '../types';

const ACTIVE_DRAWER = 'task';
const VIEW = 'swimlane'; // eslint-disable-line spellcheck/spell-checker

/**
 * Get the URL to the plan task link.
 */
export const usePlanTaskLink = (task: Task) => {
  const scheduleBaseUrl = getBaseScheduleFEUrl();
  const projectId = useCurrentProjectId();
  const currentProduct = useCurrentProjectId();
  const currentTool = useCurrentToolId();
  const sourceAnalytics = `source_product=${currentProduct}&source_tool=${currentTool}`;

  return `${scheduleBaseUrl}/projects/${projectId}/plans/${task.planId}/tasks?task=${task.id}&view=${VIEW}&activeDrawer=${ACTIVE_DRAWER}&${sourceAnalytics}`;
};
